import { SmartfireComponent, smartProps } from '@smartfire/gutenberg-react';
import React from 'react';
import { PanelBody, TextControl, ToggleControl } from '@wordpress/components';

export default class CapsaTitle extends SmartfireComponent {
    static smartProps = {
        title: smartProps.string.isRequired,
        bg: smartProps.any.withDefault('bg-white'),
        position: smartProps.any.withDefault('center'),
        type: smartProps.string.withDefault('h2'),
    };

    constructor(props) {
        super(props);
        this.elementRef = React.createRef();
    }

    componentDidMount() {
        const highlightText = [];
        let notHighlightText = [];
        const titleElements = Array.from(
            this.elementRef.current.querySelectorAll('.word-span'),
        );
        let topOffset = titleElements[0] && titleElements[0].offsetTop;
        titleElements.forEach((wordSpan, i) => {
            //Get position word span childs.
            const wordSpanTopOffset = wordSpan.offsetTop;

            //Get last offsetTop
            if (wordSpanTopOffset > topOffset) {
                //add the old highlight array to the not highlight
                notHighlightText = notHighlightText.concat(highlightText);
                //Replace the actual highlight array with a new empty one
                highlightText.length = 0;

                highlightText.push(wordSpan.innerHTML);
                topOffset = wordSpanTopOffset;
            } else if (wordSpanTopOffset === topOffset) {
                highlightText.push(wordSpan.innerHTML);
            } else {
                notHighlightText.push(wordSpan.innerHTML);
            }
        });
        //Adding highlightwrapper
        const newTitle =
            '<span>' +
            notHighlightText.join('') +
            '</span> <span class="highlight">' +
            highlightText.join('') +
            '</span>';
        //replace DOM element
        const oldTitleContainer =
            this.elementRef.current.querySelector('#title-container');
        oldTitleContainer.innerHTML = newTitle;
    }

    createTitleSpan(title) {
        const wordsSpanned = [];
        const wordArray = title.split(' ');

        wordArray.forEach((word) => {
            word !== '' &&
                wordsSpanned.push('<span class="word-span"> ' + word + '</span>');
        });
        const titleSpanned = wordsSpanned.join('');
        return titleSpanned;
    }

    renderEditInspector() {
        return (
            <PanelBody title={SmartfireComponent.__('Configuration')}>
                <TextControl
                    label="Titre capsa"
                    value={this.props.title}
                    onChange={(title) => this.setAttributes({ title: title })}
                />
                <ToggleControl
                    label="Est de type H1 ?"
                    help={this.props.type === 'h1' ? 'Est H1' : 'Est H2'}
                    checked={this.props.type === 'h1'}
                    onChange={() =>
                        this.props.type === 'h1'
                            ? this.setAttributes({ type: 'h2' })
                            : this.setAttributes({ type: 'h1' })
                    }
                />
            </PanelBody>
        );
    }

    render() {
        return (
            <div ref={this.elementRef}>
                {this.props.type === 'h1' ? (
                    <h1
                        className={
                            'capsa-title bg-' +
                            this.props.bg +
                            ' text-' +
                            this.props.text +
                            ' ' +
                            (this.props.position ? this.props.position : 'center')
                        }
                    >
                        <span
                            id={'title-container'}
                            className={'highlightColor bg-' + this.props.bg}
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                                    ? this.createTitleSpan(this.props.title)
                                    : '',
                            }}
                        />
                    </h1>
                ) : this.props.type === 'p' ? (
                    <p
                        className={
                            'capsa-title bg-' +
                            this.props.bg +
                            ' text-' +
                            this.props.text +
                            ' ' +
                            (this.props.position ? this.props.position : 'center')
                        }
                    >
                        <span
                            id={'title-container'}
                            className={'highlightColor bg-' + this.props.bg}
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                                    ? this.createTitleSpan(this.props.title)
                                    : '',
                            }}
                        />
                    </p>
                ) : (
                    <h2
                        className={
                            'capsa-title bg-' +
                            this.props.bg +
                            ' text-' +
                            this.props.text +
                            ' ' +
                            (this.props.position ? this.props.position : 'center')
                        }
                    >
                        <span
                            id={'title-container'}
                            className={'highlightColor bg-' + this.props.bg}
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                                    ? this.createTitleSpan(this.props.title)
                                    : '',
                            }}
                        />
                    </h2>
                )}
            </div>
        );
    }
}
